import axios from './axios'

async function request(api, params, config) {
    let method = api.method.toLowerCase()
    switch (method) {
        case 'get':
            return axios.get(api.path, {params, ...config})
        case 'post':
            return axios.post(api.path, params, config)
        default:
            return axios.get(api.path, {params, ...config})
    }
}

export {
    request,
}

